<h1 mat-dialog-title>{{ 'NOTIFICATIONS.ENABLE_NOTIFICATIONS_TUTORIAL' | pTranslate }}</h1>
<div mat-dialog-content fxLayout="column">ACA VAN LAS FOTOS QUE ME PASAN LOS DE PRODUCTO</div>
<div mat-dialog-actions fxLayoutAlign="end">
  <button mat-button [mat-dialog-close] color="accent" cdkFocusInitial>{{ 'GENERIC_ACCEPT' | pTranslate }}</button>
</div>
